export enum ViewMode {
  Edit = 'Edit',
  Create = 'Create'
}
